import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'custom-checkbox-accesor',
  templateUrl: './custom-checkbox-accesor.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> CustomCheckboxAccesorComponent),
      multi: true
    }
  ]
})
export class CustomCheckboxAccesorComponent implements  ControlValueAccessor {

  @Input() placeholder!: string;
  @Input() label!: string;
  value = new FormControl(false);
  @Input() labelBottomRed?: boolean = false;;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  writeValue(val: any): void {
    this.value.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    disabled ? this.value.disable() : this.value.enable();
  }

  onUserToggle() {
    const newValue = !this.value.value;
    this.value.setValue(newValue, { emitEvent: false });
    this.onChange(newValue);
    this.onTouched();
  }
}

